import http from '../../../../api/http';
import type { Voucher } from '../types/voucher';

const ENDPOINTS = {
  BASE: '/contabilidad/vouchers',
};

export class VoucherService {
  public static async getByPeriodo(idPeriodo: number, codigoFuente?: string): Promise<Voucher[]> {
    const params = codigoFuente ? `?codigoFuente=${codigoFuente}` : '';
    const response = await http.get(`${ENDPOINTS.BASE}/periodo/${idPeriodo}${params}`);
    return response.data;
  }

  public static async getById(id: number): Promise<Voucher> {
    const response = await http.get(`${ENDPOINTS.BASE}/${id}`);
    return response.data;
  }

  public static async create(voucher: Partial<Voucher>): Promise<Voucher> {
    const response = await http.post(ENDPOINTS.BASE, voucher);
    return response.data;
  }

  public static async update(id: number, voucher: Partial<Voucher>): Promise<Voucher> {
    const response = await http.put(`${ENDPOINTS.BASE}/${id}`, voucher);
    return response.data;
  }

  public static async anular(id: number): Promise<void> {
    await http.put(`${ENDPOINTS.BASE}/${id}/anular`);
  }

  public static async delete(id: number): Promise<void> {
    await http.delete(`${ENDPOINTS.BASE}/${id}`);
  }
}
